import React, { Component } from 'react';
import { connect } from 'react-redux';
import Steps, { Step } from 'rc-steps';
import PropTypes from 'prop-types';
import StepTitle from 'components/Stepper/StepTitle';
import { changeWizardStep } from 'actions/wizard';

import 'components/Stepper/style.css';
import 'rc-steps/assets/iconfont.css';

class Stepper extends Component {
  constructor(props) {
    super(props);
    this.state = { size: '', direction: 'horizontal' };
  }

  componentDidUpdate(prevProps) {
    const { app } = this.props;
    if (app.width !== prevProps.app.width) {
      this.updateState();
    }
  }

  updateState = () => {
    const { sm, xs } = this.props.app;
    this.setState({
      size: sm ? 'small' : '',
      direction: xs ? 'vertical' : 'horizontal'
    });
  };

  render() {
    const { show, steps, wizard, changeWizardStep } = this.props;
    if (!show) return null;

    const { step } = wizard;

    /* 
      Should use wizard.progressStep to return back
      to old stepper logic and for use param inside
      StepTitle use this expression:
      wizard.progressStep >= stepElem.id
    */

    const { size, direction } = this.state;

    return (
      <Steps
        current={step - 1}
        className="stepper-list"
        size={size}
        direction={direction}
      >
        {steps.map((stepElem, i) => {
          return (
            <Step
              key={i}
              title={
                <StepTitle
                  title={stepElem.title}
                  show={step >= stepElem.id}
                  handleLinkClick={() => changeWizardStep(stepElem.id)}
                />
              }
            />
          );
        })}
      </Steps>
    );
  }
}

Stepper.propTypes = {
  show: PropTypes.bool,
  steps: PropTypes.array
};

function mapStateToProps({ wizard, app }) {
  return { wizard, app };
}

export default connect(
  mapStateToProps,
  { changeWizardStep }
)(Stepper);



// WEBPACK FOOTER //
// ./src/components/Stepper/index.js